export var axTrapNames = [
    'axResolveMultiname',
    'axHasProperty',
    'axDeleteProperty',
    'axCallProperty',
    'axCallSuper',
    'axConstructProperty',
    'axHasPropertyInternal',
    'axHasOwnProperty',
    'axSetProperty',
    'axGetProperty',
    'axGetSuper',
    'axSetSuper',
    'axNextNameIndex',
    'axNextName',
    'axNextValue',
    'axGetEnumerableKeys',
    'axHasPublicProperty',
    'axSetPublicProperty',
    'axGetPublicProperty',
    'axCallPublicProperty',
    'axDeletePublicProperty',
    'axSetNumericProperty',
    'axGetNumericProperty',
    'axGetSlot',
    'axSetSlot'
];
